var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrIcons24PxFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 10 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#1d1d1b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Picto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.87,16.83a166.3,166.3,0,0,1-10,15.22V42.37l-6,4.8-2-.91V32.1a175.17,175.17,0,0,1-10-15.27V15.15H43.87ZM27.93,44.63l4-3.22V31.52a165.22,165.22,0,0,0,9.5-14.45h-23a165.22,165.22,0,0,0,9.5,14.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrIcons24PxFilter1);
export default __webpack_public_path__ + "static/media/GR_ICONS_24px_FILTER_1.e8d11259ae7339e3a6e4b092a87ce1c7.svg";
export { ForwardRef as ReactComponent };